import styled from "styled-components";

export const AreaButton = styled.div`
	> button {
		padding: 0.2rem 0;
		width: 100%;
		max-width: 120px;
		margin: 0.6rem 0 0;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		grid-row: 6;
		> button {
			margin: 0;
			padding: 0.4rem 0;
			max-width: 100%;
		}
	}
`;
export const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 1rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		grid-template-columns: 1fr;
	}
`;

export const AreaInputNumber = styled.div`
	position: relative;
`;
export const AreaCheckbox = styled.div`
	position: absolute;
	top: 14px;
	right: 0.6rem;
	margin: 0;

	.MuiFormControlLabel-root {
		margin: 0;
	}

	.MuiCheckbox-root {
		padding: 0;
	}

	.MuiCheckbox-colorSecondary.Mui-checked {
		color: #fab01c;
	}
`;
